export const MUSIC_VIDEO = 'Music Video';
export const COMMERCIAL = 'Commercial';
